import router from '../../router'

export const companies = {
    state: {
        companies: null,
        companiesForFilters: null,
        companiesActivePromos: null,
        status: 'idle',
        activeTab: 0,
        activeTabName: 'Organizatorzy',
        sortOptions: [
            {
                query: 'name',
                label: 'Nazwa'
            }
        ],
        sort: {
            by: 'name',
            direction: 'desc'
        },
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 9,
            totalRecords: null
        }
    },
    mutations: {
        SET_COMPANIES(state, payload) {
            state.companies = payload
        },
        SET_COMPANIES_ACTIVE_PROMOS(state, payload) {
            state.companiesActivePromos = payload
        },
        SET_COMPANIES_FOR_FILTERS(state, payload) {
            state.companiesForFilters = payload
        },
        SET_COMPANIES_STATUS(state, payload) {
            state.status = payload
        },
        SET_COMPANIES_ACTIVE_TAB(state, payload) {
            state.activeTab = payload
        },
        SET_COMPANIES_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_COMPANIES_PER_PAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_COMPANIES_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_COMPANIES_SORT(state, payload) {
            state.sort = payload
        },
        RESET_COMPANIES_FILTERS(state, payload) {
            state.filters = payload
        }
    },
    actions: {
        companiesFetchForFilters({ commit, state }) {
            this.$api('companies', {
                params: {
                    sort: 'name',
                    per: 99999
                }
            }).then(res => {
                commit(
                    'SET_COMPANIES_FOR_FILTERS',
                    res.data.data.map(item => {
                        return {
                            value: item.id,
                            label:
                                item.type === 'Retailer::Company'
                                    ? 'Promocje własne'
                                    : item.name
                        }
                    })
                )
            })
        },
        async companiesFetch({ commit, state, getters }, payload) {
            try {
                if (state.status === 'idle') {
                    let params = ''

                    if (router.currentRoute.query.page) {
                        commit(
                            'SET_COMPANIES_CURRENT',
                            +router.currentRoute.query.page
                        )
                    }
                    if (router.currentRoute.query.show) {
                        commit(
                            'SET_COMPANIES_PER_PAGE',
                            +router.currentRoute.query.show
                        )
                    }

                    params += `sort=${state.sort.by}&`
                    params += 'direction=' + state.sort.direction + '&'

                    commit('SET_COMPANIES_STATUS', 'loading')

                    if (getters.isLotteryUser) {
                        const res = await this.$api(
                            'lottery/get/producers/?' + params,
                            {
                                params: {
                                    page: state.pagination.page,
                                    per: state.pagination.perPage
                                }
                            }
                        )

                        commit('SET_COMPANIES', res.data.data)

                        const itemsAmount = res.data.data.length
                        const pagination = {
                            perPage: 30,
                            page: 1,
                            totalPages: 1,
                            totalRecords: itemsAmount
                        }
                        commit('SET_COMPANIES_PAGINATION', pagination)
                    } else {
                        const response = await this.$api.get(
                            'companies?' + params,
                            {
                                params: {
                                    page: state.pagination.page,
                                    per: state.pagination.perPage
                                }
                            }
                        )
                        const pagination = {
                            perPage: +response.data.pagination[0].perPage,
                            page: +response.data.pagination[0].page,
                            totalPages: +response.data.pagination[0].totalPages,
                            totalRecords: +response.data.pagination[0]
                                .totalRecords
                        }

                        const companiesResData = await this.$api(
                            'promosForCompanies?status=active'
                        )
                        commit(
                            'SET_COMPANIES_ACTIVE_PROMOS',
                            companiesResData.data.data
                        )

                        commit('SET_COMPANIES_PAGINATION', pagination)
                        commit('SET_COMPANIES', response.data.data)
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                commit('SET_COMPANIES_STATUS', 'idle')
            }
        },
        setCompaniesActiveTab({ commit }, payload) {
            commit('SET_COMPANIES_ACTIVE_TAB', payload)
        },
        setCompaniesSort({ commit }, payload) {
            commit('SET_COMPANIES_SORT', payload)
        },
        setCompaniesPagination({ commit }, payload) {
            commit('SET_COMPANIES_PAGINATION', payload)
        }
    },
    getters: {
        getCompanies: state => {
            if (state.companies) {
                return state.companies.map(value => {
                    return value.type === 'Retailer::Company'
                        ? {
                            ...value,
                            name: 'Promocje własne',
                            logo: {
                                ...value.logo,
                                urls: {
                                    big: '/img/icons/ep/own_promo.png',
                                    medium: '/img/icons/ep/own_promo.png',
                                    original: '/img/icons/ep/own_promo.png',
                                    small: '/img/icons/ep/own_promo.png'
                                }
                            }
                        }
                        : value
                })
            }
        },
        getCompaniesStatus: state => {
            return state.status
        },
        getCompaniesForFilters: state => state.companiesForFilters,
        getCompanyActivePromos: state => companyId => {
            if (state.companiesActivePromos) {
                return state.companiesActivePromos[companyId]
                    ? state.companiesActivePromos[companyId]
                    : 0
            }
        },
        getCompanyById: state => companyId => {
            if (state.companies) {
                return state.companies.find(el => el.id === companyId)
                    ? state.companies.find(el => el.id === companyId)
                    : null
            }
        },
        getCompaniesActiveTab: state => {
            return state.activeTab
        },
        getCompaniesPagination: state => {
            return state.pagination
        },
        getCompaniesSort: state => {
            return state.sort
        },
        getCompaniesSortOptions: state => {
            return state.sortOptions
        }
    }
}
